module.exports = __webpack_public_path__ + "static/scale-model-of-john-f.-kennedy-memorial-plaza-in-dallas-texas-2f487c558dbaab94357316729411a88a.png";